/**
 * There is a difference  between a not acceptable answer and a not acceptable
 * answer of the wrong type. We support that answers can be empty but empty
 * should always be defined in null. To make sure that we handle all those cases
 * we throw an error and send a silenced error in production.
 */
import { ErrorHandler } from '@angular/core';
import { isSentryErrorHandler } from '@techniek-team/sentry-web';
import { InvalidAnswerTypeError } from './errors/invalid-answer-type-error';

export function handleInvalidAnswerType(
  answer: unknown,
  errorHandler: ErrorHandler,
  isProduction: boolean,
): void {
  if (!isProduction) {
    throw new InvalidAnswerTypeError(answer);
  }

  if (isSentryErrorHandler(errorHandler)) {
    const error: InvalidAnswerTypeError = new InvalidAnswerTypeError(answer);
    errorHandler.captureError(error);
  }
}
